import React from "react";
import "../../css/MainPage/MainLanding.css";

import afford1 from "../../assets/header-images/afford1.jpg";
import understanding from "../../assets/header-images/understanding.jpg";
import scholarship from "../../assets/header-images/scholarship.jpg";
import employment from "../../assets/header-images/employment.jpg";

const sections = [
  {
    title: "Understanding Financial Aid",
    description:
      "Explore grants, scholarships, loans, and work-study programs. Learn how to apply and manage your aid.",
    image: understanding,
    link: "/afford-college/financial-aid",
    button: "Learn More",
  },
  {
    title: "Scholarships",
    description:
      "Find scholarship opportunities, application tips, and guides to help you win scholarships.",
    image: scholarship,
    link: "/afford-college/scholarship",
    button: "Explore Scholarships",
  },
  {
    title: "Student Employment",
    description:
      "Discover work opportunities and side hustles to earn money while studying.",
    image: employment,
    link: "/afford-college/student-work-opportunities",
    button: "See Jobs",
  },
];

export default function AffordCollege() {
  return (
    <div className="main-landing-page">
      {/* Hero Section */}
      <div
        className="main-landing-hero"
        style={{ backgroundImage: `url(${afford1})` }}
      >
        <div className="main-landing-hero-overlay" />
        <div className="main-landing-hero-content">
          <h1>Afford College</h1>
          <div className="main-landing-hero-sub">
            Financial aid, scholarships, and student jobs—made simple.
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="main-landing-mission-section">
        <div className="main-landing-mission-container">
          <p>
            Find clear, actionable resources to help you pay for college—without
            the clutter.
          </p>
        </div>
      </div>

      {/* Main Sections */}
      <div className="main-landing-section">
        <div className="main-landing-section-title">Ways to Afford College</div>
        <div className="main-landing-grid">
          {sections.map((section, idx) => (
            <div key={idx} className="afford-college-card">
              <div className="afford-college-card-image">
                <img src={section.image} alt={section.title} />
              </div>
              <div className="afford-college-card-content">
                <div>
                  <div className="afford-college-card-title">
                    {section.title}
                  </div>
                  <div className="afford-college-card-desc">
                    {section.description}
                  </div>
                </div>
                <a href={section.link} className="afford-college-link-btn">
                  {section.button}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
